const FuncListener = require('./generated/FuncListener').FuncListener;

var FuncDSLGenerator = function () {
  FuncListener.call(this);
  this.rootNode = null;
  this.nodeStack = [];
  this.level = 0;
  return this;
};

FuncDSLGenerator.prototype = Object.create(FuncListener.prototype);
FuncDSLGenerator.prototype.constructor = FuncDSLGenerator;

FuncDSLGenerator.prototype.getFuncDSLObject = function () {
  return this.rootNode;
};

FuncDSLGenerator.prototype.enterFunc = function (ctx) {
  this.level++;
  var node = { type: 'attributeRef' };

  if (ctx.FNAME() != null) {
    node.type = 'function';
    node.name = ctx.FNAME().getText().substring(1);
  } else if (ctx.ATNAME() != null) {
    node.accessor = ctx.ATNAME().getText();
  } else if (ctx.PNAME() != null) {
    node.accessor = ctx.PNAME().getText();
  } else if (ctx.ENAME() != null) {
    node.accessor = ctx.ENAME().getText();
  }

  this.nodeStack.unshift(node);
};

FuncDSLGenerator.prototype.exitFunc = function (ctx) {
  this.level--;
  var node = this.nodeStack.shift();

  if (this.nodeStack.length > 0) {
    this.nodeStack[0].parameters.push(node);
  } else {
    this.rootNode = node;
  }
};

FuncDSLGenerator.prototype.enterParams = function (ctx) {
  this.nodeStack[0].parameters = [];
};

FuncDSLGenerator.prototype.exitParams = function (ctx) {};

FuncDSLGenerator.prototype.enterArray = function (ctx) {
  var arrayNode = { type: 'array', parameters: [] };
  this.nodeStack.unshift(arrayNode);
};

FuncDSLGenerator.prototype.exitArray = function (ctx) {
  var arrayNode = this.nodeStack.shift();
  if (this.nodeStack.length > 0) {
    arrayNode.items = arrayNode.parameters;
    delete arrayNode.parameters;
    this.nodeStack[0].parameters.push(arrayNode);
  }
};

FuncDSLGenerator.prototype.enterAtom = function (ctx) {};

FuncDSLGenerator.prototype.exitAtom = function (ctx) {};

FuncDSLGenerator.prototype.enterPathref = function (ctx) {};

FuncDSLGenerator.prototype.exitPathref = function (ctx) {};

FuncDSLGenerator.prototype.enterContextref = function (ctx) {};

FuncDSLGenerator.prototype.exitContextref = function (ctx) {
  this.nodeStack[0].parameters.push({
    type: 'systemAttributeRef',
    parameters: [{ type: 'attributeName', value: ctx.getText().substring(1) }],
  });
};

FuncDSLGenerator.prototype.enterString = function (ctx) {};

FuncDSLGenerator.prototype.exitString = function (ctx) {
  var str = ctx.getText().replace(/'/g, '');
  this.nodeStack[0].parameters.push({ type: 'string', value: str });
};

FuncDSLGenerator.prototype.enterLiteral = function (ctx) {};

FuncDSLGenerator.prototype.exitLiteral = function (ctx) {};

FuncDSLGenerator.prototype.enterNumber = function (ctx) {};

FuncDSLGenerator.prototype.exitNumber = function (ctx) {
  var num = parseFloat(ctx.getText());
  this.nodeStack[0].parameters.push({ type: 'number', value: num });
};

FuncDSLGenerator.prototype.enterVariable = function (ctx) {};

FuncDSLGenerator.prototype.exitVariable = function (ctx) {
  this.nodeStack[0].parameters.push({
    type: 'attributeName',
    value: ctx.getText(),
  });
};

exports.FuncDSLGenerator = FuncDSLGenerator;
